import { render, staticRenderFns } from "./PcaWidget.vue?vue&type=template&id=2f70b624&"
import script from "./PcaWidget.vue?vue&type=script&lang=js&"
export * from "./PcaWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports